import {useAuth} from '@apps-common/auth-react';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/EditOutlined';
import LoginIcon from '@mui/icons-material/LoginOutlined';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import {arrayOf, bool, node, string} from 'prop-types';
import React, {useCallback, useEffect} from 'react';
import Logo from '../assets/planet-logo.svg';
import Footer from './Footer.jsx';
import Link from './Link.jsx';

export const newLink = (
  <Link to="/new" key="new">
    <Tooltip title="new publication">
      <AddIcon sx={{marginLeft: 1}} />
    </Tooltip>
  </Link>
);

export const editLink = (
  <Link to="./edit" key="edit">
    <Tooltip title="edit publication">
      <EditIcon sx={{marginLeft: 1}} />
    </Tooltip>
  </Link>
);

function Page({title, children, scroll = true, links = [], withFooter = true}) {
  const auth = useAuth();

  useEffect(() => {
    document.title = title || 'Publications';
  }, [title]);

  const signOut = useCallback(() => {
    auth.signOut();
  }, [auth]);

  const signIn = useCallback(() => {
    auth.signIn();
  }, [auth]);

  const overflow = scroll ? 'visible' : 'hidden';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        minHeight: '100%',
        width: '100%',
        top: 0,
      }}
    >
      <AppBar color="inherit" sx={{backgroundColor: 'black'}} elevation={1}>
        <Toolbar>
          <img
            src={Logo}
            alt="Planet Logo"
            style={{height: 40, marginRight: 15}}
          />
          <Typography>
            <Link to="/" sx={{color: 'white', fontWeight: '700'}}>
              PUBLICATIONS
            </Link>
          </Typography>
          <Box
            sx={{marginLeft: 'auto', display: 'flex', alignItems: 'baseline'}}
          >
            {links}
            {auth.user && (
              <IconButton
                sx={{marginLeft: 1}}
                color="primary"
                onClick={signOut}
              >
                <Tooltip title="sign out">
                  <LogoutIcon />
                </Tooltip>
              </IconButton>
            )}
            {!auth.pending && !auth.user && (
              <IconButton sx={{marginLeft: 1}} color="primary" onClick={signIn}>
                <Tooltip title="sign in">
                  <LoginIcon />
                </Tooltip>
              </IconButton>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Box
        sx={{overflow, display: 'flex', flexDirection: 'column', flexGrow: 1}}
      >
        <Container
          maxWidth="lg"
          sx={{
            overflow,
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 3,
            flexGrow: 1,
          }}
        >
          {children}
        </Container>
      </Box>
      {withFooter && (
        <Box px={3}>
          <Footer />
        </Box>
      )}
    </Box>
  );
}

Page.propTypes = {
  title: string,
  children: node,
  links: arrayOf(node),
  scroll: bool,
  withFooter: bool,
};

export default Page;
